import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MarginService {
  public getServiceOperatorPayload(
    buyerMargin: string,
    byrCpi: string,
    enableTargetMargin: boolean | undefined,
    marginAccepted: boolean
  ) {
    return {
      userAcceptedMargin: marginAccepted,
      isEnableMarginOverride: enableTargetMargin,
      margin_override: { enable: true, margin: buyerMargin },
      margin: buyerMargin,
      offer_price: byrCpi,
    };
  }
}
